// // final

// import React, { useEffect, useState } from "react";
// import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
// import LoginPage from "./components/LoginPage";
// import TherapyRooms from "./components/TherapyRooms/TherapyRooms";
// import UnityRoom from "./components/TherapyRooms/UnityRoom";
// import TestPage from "./components/TherapyRooms/TestPage";
// import AdminPage from "./pages/admin/AdminPage";
// import allowedUserIds from "./pages/admin/adminConfig";
// import ClientTherapyRooms from "./components/TherapyRooms/ClientTherapyRooms";
// import TherapistTherapyRooms from "./components/TherapyRooms/TherapistTherapyRooms";
// import CreateMeetingDashboard from "./pages/admin/CreateMeetingDashboard";
// import UpdateMeetingDashboard from "./pages/admin/UpdateMeetingDashboard";
// import AdminResendPasswordDashboard from "./pages/admin/AdminResendPasswordDashboard";
// import Env from './runtimeEnv';

// import axios from "axios";

// function App() {
//   const navigate = useNavigate();

//   const [currentNickname, setCurrentNickname] = useState("");
//   const [currentFormType, setCurrentFormType] = useState("login");
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [PlutonicuserID, setPlutonicuserID] = useState("");
//   const [loading, setLoading] = useState(true); // New loading state
//   const [isAdmin, setIsAdmin] = useState(false);
//   const [userType, setUserType] = useState(
//     localStorage.getItem("userType") || ""
//   );

//   useEffect(() => {
//     const storedUserType = localStorage.getItem("userType");
//     if (storedUserType) {
//       setUserType(storedUserType);
//     }
//   }, []);

//   const idleTimeout = 60 * 60 * 1000; // Idle timeout duration (10 minutes)
//   let idleTimer = null;

//   // Synchronize state with localStorage on app load
//   useEffect(() => {
//     const restoreSession = async () => {
//       const savedNickname = localStorage.getItem("currentNickname");
//       const savedPlutonicuserID = localStorage.getItem("PlutonicuserID");
//       const lastActiveTime = localStorage.getItem("lastActiveTime");
//       const sessionActive = sessionStorage.getItem("sessionActive");

//       if (lastActiveTime) {
//         const now = new Date();
//         const lastActiveDate = new Date(lastActiveTime);
//         const differenceInMinutes = Math.floor(
//           (now - lastActiveDate) / (1000 * 60)
//         );

//         // If more than 5 minutes have passed since the last activity
//         if (differenceInMinutes >= 60) {
//           // console.log('[App] User session expired due to tab inactivity.');
//           handleLogout();
//           return;
//         }
//       }

//       if (!sessionActive) {
//         // console.log('[App] Initializing session...');
//         sessionStorage.setItem("sessionActive", "true");
//         setIsAuthenticated(false);
//       } else if (savedNickname && savedPlutonicuserID) {
//         // console.log('[App] Restoring user state from localStorage...');
//         setCurrentNickname(savedNickname);
//         setPlutonicuserID(savedPlutonicuserID);
//         setIsAuthenticated(true);
//         setIsAdmin(allowedUserIds.includes(savedPlutonicuserID));

//         // Restore the last visited page
//         const lastVisitedPage = localStorage.getItem("lastVisitedPage") || "/";
//         if (lastVisitedPage && window.location.pathname === "/") {
//           navigate(lastVisitedPage, { replace: true });
//         }
//       }

//       setLoading(false); // End loading once the session is restored
//     };

//     restoreSession();
//   }, [navigate]);

//   // Idle timeout handler
//   const resetIdleTimer = () => {
//     if (idleTimer) clearTimeout(idleTimer);
//     idleTimer = setTimeout(() => {
//       // console.log('[App] User logged out due to inactivity.');
//       handleLogout(); // Logout user if idle
//     }, idleTimeout);
//   };

//   // Handle tab close to set online status to false
//   useEffect(() => {
//     const handleTabClose = () => {
//       const lastActiveTime = new Date().toISOString();
//       localStorage.setItem("lastActiveTime", lastActiveTime);

//       const meetingID = sessionStorage.getItem("meetingID");
//       const PlutonicuserID = localStorage.getItem("PlutonicuserID");

//       if (meetingID && PlutonicuserID) {
//         const payload = { meetingID, online: false };
//         // console.log('[App] Sending tab close payload:', payload);

//         navigator.sendBeacon(
//           `${Env.REACT_APP_PYTHON_API_URL}/api/set-online-status/${PlutonicuserID}`,
//           JSON.stringify(payload)
//         );
//       }
//     };

//     window.addEventListener("beforeunload", handleTabClose);

//     return () => {
//       window.removeEventListener("beforeunload", handleTabClose);
//     };
//   }, []);

//   const handleLogout = async () => {
//     try {
//       const meetingID = sessionStorage.getItem("meetingID");
//       const PlutonicuserID = localStorage.getItem("PlutonicuserID");

//       if (meetingID && PlutonicuserID) {
//         // console.log('[App] Attempting to set online status to false...');
//         await axios.post(
//           `${Env.REACT_APP_PYTHON_API_URL}/api/set-online-status/${PlutonicuserID}`,
//           { meetingID, online: false }
//         );
//         // console.log('[App] Online status successfully set to false for logout.');
//       }

//       // console.log('[App] Logging out from Cognito...');
//       await axios.post(`${Env.REACT_APP_PYTHON_API_URL}/api/logout`);
//       // console.log('[App] Successfully logged out.');
//     } catch (err) {
//       if (err.response?.status === 500) {
//         console.warn(
//           "[App] Logout failed on the server, possibly due to expired token."
//         );
//       } else {
//         console.error("[App] Failed during logout process:", err);
//       }
//     } finally {
//       // console.log('[App] Clearing session and local storage.');
//       localStorage.clear();
//       sessionStorage.clear();
//       setCurrentNickname("");
//       setPlutonicuserID("");
//       setCurrentFormType("login");
//       setIsAuthenticated(false);
//       setIsAdmin(false);
//       setLoading(false); // Update loading to false
//     }
//   };

//   // Track user activity to reset idle timer
//   useEffect(() => {
//     if (isAuthenticated) {
//       const events = ["mousemove", "keypress", "click"];
//       const resetTimer = () => resetIdleTimer();

//       events.forEach((event) => window.addEventListener(event, resetTimer));

//       // Initialize the idle timer
//       resetIdleTimer();

//       return () => {
//         // Cleanup event listeners and timer when component unmounts
//         events.forEach((event) =>
//           window.removeEventListener(event, resetTimer)
//         );
//         if (idleTimer) clearTimeout(idleTimer);
//       };
//     }
//   }, [isAuthenticated]);

//   // Update nickname function
//   const updateNickname = (nickname) => {
//     setCurrentNickname(nickname);
//     if (nickname) {
//       localStorage.setItem("currentNickname", nickname);
//       setIsAuthenticated(true);
//     } else {
//       localStorage.removeItem("currentNickname");
//       setIsAuthenticated(false);
//     }
//   };

//   if (loading) {
//     // Show a loading spinner or message while session restoration is in progress
//     return (
//       <div
//         style={{
//           height: "100vh",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         <p>Loading...</p>
//       </div>
//     );
//   }

//   return (
//     <div className="App">
//       <Routes>
//         <Route
//           path="/"
//           element={
//             isAuthenticated ? (
//               userType === "Client" || !userType ? (
//                 <ClientTherapyRooms
//                   currentNickname={currentNickname}
//                   setCurrentNickname={setCurrentNickname}
//                   handleLogout={() => setIsAuthenticated(false)}
//                   setFormType={setCurrentFormType}
//                   PlutonicuserID={PlutonicuserID}
//                   userType="Client"
//                 />
//               ) : userType === "Therapist" ? (
//                 <TherapistTherapyRooms
//                   currentNickname={currentNickname}
//                   setCurrentNickname={setCurrentNickname}
//                   handleLogout={() => setIsAuthenticated(false)}
//                   setFormType={setCurrentFormType}
//                   PlutonicuserID={PlutonicuserID}
//                   userType="Therapist"
//                 />
//               ) : (
//                 // <p className="text-center text-red-500">Invalid user type</p> // Default case if userType is missing
//                 <ClientTherapyRooms
//                   currentNickname={currentNickname}
//                   setCurrentNickname={setCurrentNickname}
//                   handleLogout={() => setIsAuthenticated(false)}
//                   setFormType={setCurrentFormType}
//                   PlutonicuserID={PlutonicuserID}
//                   userType="Client"
//                 />
//               )
//             ) : (
//               <LoginPage
//                 setCurrentNickname={setCurrentNickname}
//                 setPlutonicuserID={setPlutonicuserID}
//                 setFormType={setCurrentFormType}
//                 setIsAuthenticated={setIsAuthenticated}
//               />
//             )
//           }
//         />

//         {/* <Route
//         path="/"
//         element={
//           isAuthenticated ? (
//             userType === "Client" ? (
//               <ClientTherapyRooms
//                 currentNickname={currentNickname}
//                 setCurrentNickname={setCurrentNickname}
//                 handleLogout={() => setIsAuthenticated(false)}
//                 setFormType={setCurrentFormType}
//                 PlutonicuserID={PlutonicuserID}
//               />
//             ) : userType === "Therapist" ? (
//               <TherapistTherapyRooms
//                 currentNickname={currentNickname}
//                 setCurrentNickname={setCurrentNickname}
//                 handleLogout={() => setIsAuthenticated(false)}
//                 setFormType={setCurrentFormType}
//                 PlutonicuserID={PlutonicuserID}
//               />
//             ) : (
//               <p className="text-center text-red-500">Invalid user type</p> // Default case if userType is missing
//             )
//           ) : (
//             <LoginPage
//               setCurrentNickname={setCurrentNickname}
//               setPlutonicuserID={setPlutonicuserID}
//               setFormType={setCurrentFormType}
//               setIsAuthenticated={setIsAuthenticated}
//             />
//           )
//         }
//       /> */}

//         <Route
//           path="/unity-room/:roomType"
//           element={
//             isAuthenticated ? (
//               <UnityRoom
//                 currentNickname={currentNickname}
//                 setCurrentNickname={updateNickname}
//                 handleLogout={handleLogout}
//                 setFormType={setCurrentFormType}
//                 PlutonicuserID={PlutonicuserID}
//               />
//             ) : (
//               <Navigate to="/" replace />
//             )
//           }
//         />

//         <Route
//           path="/testpage"
//           element={
//             <TestPage
//               currentNickname={currentNickname}
//               setCurrentNickname={updateNickname}
//               handleLogout={handleLogout}
//               setFormType={setCurrentFormType}
//               PlutonicuserID={PlutonicuserID}
//             />
//           }
//         />
//         <Route
//           path="/admin"
//           element={
//             isAdmin ? (
//               <AdminPage
//                 currentNickname={currentNickname}
//                 setCurrentNickname={updateNickname}
//                 handleLogout={handleLogout}
//                 setFormType={setCurrentFormType}
//                 PlutonicuserID={PlutonicuserID}
//               />
//             ) : (
//               <Navigate to="/" replace />
//             )
//           }
//         />

//         {/* <Route
//           path="/admin/createmeeting"
//           element={
//             isAdmin ? (
//               <CreateMeetingDashboard
//                 currentNickname={currentNickname}
//                 setCurrentNickname={updateNickname}
//                 handleLogout={handleLogout}
//                 setFormType={setCurrentFormType}
//                 PlutonicuserID={PlutonicuserID}
//               />
//             ) : (
//               <Navigate to="/" replace />
//             )
//           }
//         /> */}

// <Route
//   path="/admin/createmeeting"
//   element={
//     <CreateMeetingDashboard
//       currentNickname={currentNickname}
//       setCurrentNickname={updateNickname}
//       handleLogout={handleLogout}
//       setFormType={setCurrentFormType}
//       PlutonicuserID={PlutonicuserID}
//       isAdmin={isAdmin}
//     />
//   }
// />



//         <Route
//           path="/admin/updatemeeting"
//           element={
//             isAdmin ? (
//               <UpdateMeetingDashboard
//                 currentNickname={currentNickname}
//                 setCurrentNickname={updateNickname}
//                 handleLogout={handleLogout}
//                 setFormType={setCurrentFormType}
//                 PlutonicuserID={PlutonicuserID}
//                 isAdmin={isAdmin}
//               />
//             ) : (
//               <Navigate to="/" replace />
//             )
//           }
//         />
//         <Route
//           path="/admin/resendpassword"
//           element={
//             isAdmin ? (
//               <AdminResendPasswordDashboard
//                 currentNickname={currentNickname}
//                 setCurrentNickname={updateNickname}
//                 handleLogout={handleLogout}
//                 setFormType={setCurrentFormType}
//                 PlutonicuserID={PlutonicuserID}
//                 isAdmin={isAdmin}
//               />
//             ) : (
//               <Navigate to="/" replace />
//             )
//           }
//         />

//         <Route path="*" element={<Navigate to="/" replace />} />
//       </Routes>
//     </div>
//   );
// }

// export default App;


// final

import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import LoginPage from "./components/LoginPage";
import TherapyRooms from "./components/TherapyRooms/TherapyRooms";
import UnityRoom from "./components/TherapyRooms/UnityRoom";
import TestPage from "./components/TherapyRooms/TestPage";
import AdminPage from "./pages/admin/AdminPage";
import allowedUserIds from "./pages/admin/adminConfig";
import ClientTherapyRooms from "./components/TherapyRooms/ClientTherapyRooms";
import TherapistTherapyRooms from "./components/TherapyRooms/TherapistTherapyRooms";
import CreateMeetingDashboard from "./pages/admin/CreateMeetingDashboard";
import UpdateMeetingDashboard from "./pages/admin/UpdateMeetingDashboard";
import AdminResendPasswordDashboard from "./pages/admin/AdminResendPasswordDashboard";
import DemoPage from "./components/Demo/DemoPage";
import Env from './runtimeEnv';

import axios from "axios";

function App() {
  const navigate = useNavigate();

  const [currentNickname, setCurrentNickname] = useState("");
  const [currentFormType, setCurrentFormType] = useState("login");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [PlutonicuserID, setPlutonicuserID] = useState("");
  const [loading, setLoading] = useState(true); // New loading state
  const [isAdmin, setIsAdmin] = useState(false);
  const [userType, setUserType] = useState(
    localStorage.getItem("userType") || ""
  );

  useEffect(() => {
    const storedUserType = localStorage.getItem("userType");
    if (storedUserType) {
      setUserType(storedUserType);
    }
  }, []);

  const idleTimeout = 60 * 60 * 1000; // Idle timeout duration (10 minutes)
  let idleTimer = null;

  // Synchronize state with localStorage on app load
  useEffect(() => {
    const restoreSession = async () => {
      const savedNickname = localStorage.getItem("currentNickname");
      const savedPlutonicuserID = localStorage.getItem("PlutonicuserID");
      const lastActiveTime = localStorage.getItem("lastActiveTime");
      const sessionActive = sessionStorage.getItem("sessionActive");

      if (lastActiveTime) {
        const now = new Date();
        const lastActiveDate = new Date(lastActiveTime);
        const differenceInMinutes = Math.floor(
          (now - lastActiveDate) / (1000 * 60)
        );

        // If more than 5 minutes have passed since the last activity
        if (differenceInMinutes >= 60) {
          // console.log('[App] User session expired due to tab inactivity.');
          handleLogout();
          return;
        }
      }

      if (!sessionActive) {
        // console.log('[App] Initializing session...');
        sessionStorage.setItem("sessionActive", "true");
        setIsAuthenticated(false);
      } else if (savedNickname && savedPlutonicuserID) {
        // console.log('[App] Restoring user state from localStorage...');
        setCurrentNickname(savedNickname);
        setPlutonicuserID(savedPlutonicuserID);
        setIsAuthenticated(true);
        setIsAdmin(allowedUserIds.includes(savedPlutonicuserID));

        // Restore the last visited page
        const lastVisitedPage = localStorage.getItem("lastVisitedPage") || "/";
        if (lastVisitedPage && window.location.pathname === "/") {
          navigate(lastVisitedPage, { replace: true });
        }
      }

      setLoading(false); // End loading once the session is restored
    };

    restoreSession();
  }, [navigate]);

  // Idle timeout handler
  const resetIdleTimer = () => {
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = setTimeout(() => {
      // console.log('[App] User logged out due to inactivity.');
      handleLogout(); // Logout user if idle
    }, idleTimeout);
  };

  // Handle tab close to set online status to false
  useEffect(() => {
    const handleTabClose = () => {
      const lastActiveTime = new Date().toISOString();
      localStorage.setItem("lastActiveTime", lastActiveTime);

      const meetingID = sessionStorage.getItem("meetingID");
      const PlutonicuserID = localStorage.getItem("PlutonicuserID");

      if (meetingID && PlutonicuserID) {
        const payload = { meetingID, online: false };
        // console.log('[App] Sending tab close payload:', payload);

        navigator.sendBeacon(
          `${Env.REACT_APP_PYTHON_API_URL}/api/set-online-status/${PlutonicuserID}`,
          JSON.stringify(payload)
        );
      }
    };

    window.addEventListener("beforeunload", handleTabClose);

    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
    };
  }, []);

  const handleLogout = async () => {
    try {
      const meetingID = sessionStorage.getItem("meetingID");
      const PlutonicuserID = localStorage.getItem("PlutonicuserID");

      if (meetingID && PlutonicuserID) {
        // console.log('[App] Attempting to set online status to false...');
        await axios.post(
          `${Env.REACT_APP_PYTHON_API_URL}/api/set-online-status/${PlutonicuserID}`,
          { meetingID, online: false }
        );
        // console.log('[App] Online status successfully set to false for logout.');
      }

      // console.log('[App] Logging out from Cognito...');
      await axios.post(`${Env.REACT_APP_PYTHON_API_URL}/api/logout`);
      // console.log('[App] Successfully logged out.');
    } catch (err) {
      if (err.response?.status === 500) {
        console.warn(
          "[App] Logout failed on the server, possibly due to expired token."
        );
      } else {
        console.error("[App] Failed during logout process:", err);
      }
    } finally {
      // console.log('[App] Clearing session and local storage.');
      localStorage.clear();
      sessionStorage.clear();
      setCurrentNickname("");
      setPlutonicuserID("");
      setCurrentFormType("login");
      setIsAuthenticated(false);
      setIsAdmin(false);
      setLoading(false); // Update loading to false
    }
  };

  // Track user activity to reset idle timer
  useEffect(() => {
    if (isAuthenticated) {
      const events = ["mousemove", "keypress", "click"];
      const resetTimer = () => resetIdleTimer();

      events.forEach((event) => window.addEventListener(event, resetTimer));

      // Initialize the idle timer
      resetIdleTimer();

      return () => {
        // Cleanup event listeners and timer when component unmounts
        events.forEach((event) =>
          window.removeEventListener(event, resetTimer)
        );
        if (idleTimer) clearTimeout(idleTimer);
      };
    }
  }, [isAuthenticated]);

  // Update nickname function
  const updateNickname = (nickname) => {
    setCurrentNickname(nickname);
    if (nickname) {
      localStorage.setItem("currentNickname", nickname);
      setIsAuthenticated(true);
    } else {
      localStorage.removeItem("currentNickname");
      setIsAuthenticated(false);
    }
  };

  if (loading) {
    // Show a loading spinner or message while session restoration is in progress
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="App">
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated ? (
              userType === "Client" || !userType ? (
                <ClientTherapyRooms
                  currentNickname={currentNickname}
                  setCurrentNickname={setCurrentNickname}
                  handleLogout={() => setIsAuthenticated(false)}
                  setFormType={setCurrentFormType}
                  PlutonicuserID={PlutonicuserID}
                  userType="Client"
                />
              ) : userType === "Therapist" ? (
                <TherapistTherapyRooms
                  currentNickname={currentNickname}
                  setCurrentNickname={setCurrentNickname}
                  handleLogout={() => setIsAuthenticated(false)}
                  setFormType={setCurrentFormType}
                  PlutonicuserID={PlutonicuserID}
                  userType="Therapist"
                />
              ) : (
                // <p className="text-center text-red-500">Invalid user type</p> // Default case if userType is missing
                <ClientTherapyRooms
                  currentNickname={currentNickname}
                  setCurrentNickname={setCurrentNickname}
                  handleLogout={() => setIsAuthenticated(false)}
                  setFormType={setCurrentFormType}
                  PlutonicuserID={PlutonicuserID}
                  userType="Client"
                />
              )
            ) : (
              <LoginPage
                setCurrentNickname={setCurrentNickname}
                setPlutonicuserID={setPlutonicuserID}
                setFormType={setCurrentFormType}
                setIsAuthenticated={setIsAuthenticated}
              />
            )
          }
        />

        {/* <Route
        path="/"
        element={
          isAuthenticated ? (
            userType === "Client" ? (
              <ClientTherapyRooms
                currentNickname={currentNickname}
                setCurrentNickname={setCurrentNickname}
                handleLogout={() => setIsAuthenticated(false)}
                setFormType={setCurrentFormType}
                PlutonicuserID={PlutonicuserID}
              />
            ) : userType === "Therapist" ? (
              <TherapistTherapyRooms
                currentNickname={currentNickname}
                setCurrentNickname={setCurrentNickname}
                handleLogout={() => setIsAuthenticated(false)}
                setFormType={setCurrentFormType}
                PlutonicuserID={PlutonicuserID}
              />
            ) : (
              <p className="text-center text-red-500">Invalid user type</p> // Default case if userType is missing
            )
          ) : (
            <LoginPage
              setCurrentNickname={setCurrentNickname}
              setPlutonicuserID={setPlutonicuserID}
              setFormType={setCurrentFormType}
              setIsAuthenticated={setIsAuthenticated}
            />
          )
        }
      /> */}

        <Route
          path="/unity-room/:roomType"
          element={
            isAuthenticated ? (
              <UnityRoom
                currentNickname={currentNickname}
                setCurrentNickname={updateNickname}
                handleLogout={handleLogout}
                setFormType={setCurrentFormType}
                PlutonicuserID={PlutonicuserID}
              />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        <Route
          path="/testpage"
          element={
            <TestPage
              currentNickname={currentNickname}
              setCurrentNickname={updateNickname}
              handleLogout={handleLogout}
              setFormType={setCurrentFormType}
              PlutonicuserID={PlutonicuserID}
            />
          }
        />
        <Route
          path="/demo-beach"
          element={
            <DemoPage
              currentNickname={currentNickname}
              setCurrentNickname={updateNickname}
              handleLogout={handleLogout}
              setFormType={setCurrentFormType}
              PlutonicuserID={PlutonicuserID}
            />
          }
        />
        <Route
          path="/admin"
          element={
            isAdmin ? (
              <AdminPage
                currentNickname={currentNickname}
                setCurrentNickname={updateNickname}
                handleLogout={handleLogout}
                setFormType={setCurrentFormType}
                PlutonicuserID={PlutonicuserID}
              />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        {/* <Route
          path="/admin/createmeeting"
          element={
            isAdmin ? (
              <CreateMeetingDashboard
                currentNickname={currentNickname}
                setCurrentNickname={updateNickname}
                handleLogout={handleLogout}
                setFormType={setCurrentFormType}
                PlutonicuserID={PlutonicuserID}
              />
            ) : (
              <Navigate to="/" replace />
            )
          }
        /> */}

<Route
  path="/admin/createmeeting"
  element={
    <CreateMeetingDashboard
      currentNickname={currentNickname}
      setCurrentNickname={updateNickname}
      handleLogout={handleLogout}
      setFormType={setCurrentFormType}
      PlutonicuserID={PlutonicuserID}
      isAdmin={isAdmin}
    />
  }
/>



        <Route
          path="/admin/updatemeeting"
          element={
            isAdmin ? (
              <UpdateMeetingDashboard
                currentNickname={currentNickname}
                setCurrentNickname={updateNickname}
                handleLogout={handleLogout}
                setFormType={setCurrentFormType}
                PlutonicuserID={PlutonicuserID}
                isAdmin={isAdmin}
              />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="/admin/resendpassword"
          element={
            isAdmin ? (
              <AdminResendPasswordDashboard
                currentNickname={currentNickname}
                setCurrentNickname={updateNickname}
                handleLogout={handleLogout}
                setFormType={setCurrentFormType}
                PlutonicuserID={PlutonicuserID}
                isAdmin={isAdmin}
              />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default App;